import React from 'react'
import { SearchPreview } from '../components/searchPreview'
import { SearchResultRow } from '../components/searchResultRow'

type PropsType = {
  config: any
  colors: any
  sectionNumber: number
  setSection: (index: number) => void
  activeRowIndex: number
  setActiveRowIndex: (num: number) => void
  executeAction: (entry: any, cmdPressed: boolean) => void
  search: string
  previewMode?: boolean
}

export const queryConfig = (config: any, search: string) => {
  const items = []

  const categories = Object.keys(config)
  for (var i = 0; i < categories.length; i++) {
    const category = categories[i]
    const entries = config[category]
    for (var j = 0; j < entries.length; j++) {
      const entry = entries[j]

      items.push({
        category: category,
        entity: entry
      })
    }
  }

  return items
    .filter(({ entity }: any) =>
      JSON.stringify(entity).toLowerCase().includes(search.toLowerCase())
    )
    .map((entry: any) => entry.entity)
}

export const SearchResults = (props: PropsType) => {
  var config = props.config
  var setActiveRowIndex = props.setActiveRowIndex
  var activeRowIndex = props.activeRowIndex
  var executeAction = props.executeAction
  var search = props.search

  const configIndex = queryConfig(config, search)

  if (configIndex.length === 0) {
    return (
      <div
        style={{
          padding: 16,
          textAlign: 'center'
        }}
      >
        <p
          style={{
            color: props.colors?.text ? props.colors.text : 'white'
          }}
        >
          no results found
        </p>
      </div>
    )
  }

  const activeEntry = configIndex[activeRowIndex]
  const showPreview = activeEntry?.preview !== undefined

  return (
    <div>
      <br />
      <div style={{ flexDirection: 'row', display: 'flex' }}>
        <div
          style={{
            maxHeight: '300px',
            overflowY: 'hidden',
            paddingBottom: 12,
            width: !showPreview ? '100%' : '60%',
            overflowX: 'clip'
          }}
        >
          {configIndex.map((entry: any, index: number) => {
            const active = activeRowIndex === index
            const uuid = entry.uuid
            return (
              <SearchResultRow
                active={active}
                colors={props.colors}
                setActiveRowIndex={setActiveRowIndex}
                executeAction={executeAction}
                index={index}
                entry={entry}
                key={uuid}
                previewMode={props.previewMode}
              />
            )
          })}
        </div>

        {showPreview && (
          <SearchPreview
            entry={activeEntry}
            executeAction={executeAction}
            colors={props.colors}
          />
        )}
      </div>
    </div>
  )
}
